// ============================================
// Error de reserva
// ============================================
export const PaymentWizardError = ({ onClose }: { onClose: () => void }) => (
    <div className="flex flex-col items-center justify-center min-h-[40vh] space-y-6 text-white">
        <div className="w-20 h-20 rounded-full flex items-center justify-center bg-red-500/20 border-4 border-red-400">
            <svg className="w-12 h-12 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
        </div>
        <div className="text-center space-y-2 max-w-md">
            <h2 className="text-2xl font-display text-red-400">
                Ups! Parece que alguien ya compró estas entradas.
            </h2>
        </div>
        <button
            onClick={onClose}
            className="bg-white/10 hover:bg-white/20 border border-white/20 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
            Volver a seleccionar los asientos
        </button>
    </div>
);